import { createContext } from 'react';

export const EditorSectionContext = createContext<{
  section: unknown;
  setSection: (section: string) => void;
} | null>(null);

export function editorSectionSearch(search: Record<string, unknown>): { section?: string } {
  return typeof search['section'] === 'string' ? { section: search['section'] } : {};
}

export function isEditorSectionNavigation(
  current: { pathname: string; search: object },
  next: { pathname: string; search: object },
): boolean {
  const currentSearch = current.search as Record<string, unknown>;
  const nextSearch = next.search as Record<string, unknown>;
  if (current.pathname !== next.pathname || currentSearch['section'] === nextSearch['section']) {
    return false;
  }
  const keys = new Set([...Object.keys(current.search), ...Object.keys(next.search)]);
  keys.delete('section');
  return [...keys].every(
    (key) => JSON.stringify(currentSearch[key]) === JSON.stringify(nextSearch[key]),
  );
}

/**
 * A stable setter for the routed section. Editors read this instead of the section itself, so a
 * tab switch re-renders only the tabs, not the whole form (see `EditorSectionTabs`).
 */
export const EditorSectionSetterContext = createContext<((section: string) => void) | null>(null);
